module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [(_vm.menu_tab_inner_view['premiumMember']) ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('');
        _vm.toggleSingleComponent('xInfo');
      }
    }
  }, [_c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Become a premium shop owner")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('premiumMember')
      }
    }
  }, [_c('span', [_vm._v("Your Plan starts at N35,000 per year")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "letter-spacing": "2.2"
    }
  }, [_vm._v("ACTIVATE")])])])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_vm._m(2), _vm._v(" "), _c('h4', [_vm._v("Welcome " + _vm._s(_vm.user.user_name))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "text-transform": "uppercase"
    }
  }, [_vm._v("sales today")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.total_sales_today)))])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(4), _vm._v(" "), _vm._l((_vm.set_ordered_items), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-3"
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "5px"
      },
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "5px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(item.product_name)), _c('br'), _vm._v(" "), (item.product_item_service_tag != 'Nill') ? _c('span', [_vm._v("(" + _vm._s(item.product_item_service_tag) + ")")]) : _vm._e()])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.set_order_quantity))])])
  })], 2)])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [(!_vm.menu_tab_inner_view['premiumMember']) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('xInfo')
      }
    }
  }, [_c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('premiumMember')
      }
    }
  }, [_vm._v("\r\n        Become a premium shop owner")]), _vm._v(" "), _vm._m(7)])]) : _vm._e()]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")]), _vm._v("Only Premuim Shop Oners get verified and have access to benefits")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#2c2c2c"
    }
  }, [_c('p', [_vm._v("1. Access Professional Dashboard")]), _vm._v(" "), _c('p', [_vm._v("2. Manage your shop with more than one persons")]), _vm._v(" "), _c('p', [_vm._v("3. Enjoy Shopping pst referrals")]), _vm._v(" "), _c('p', [_vm._v("4. Offer Discounts and Coupon Codes")]), _vm._v(" "), _c('p', [_vm._v("5. Access Professional Dashboard")]), _vm._v(" "), _c('p', [_vm._v("6. Manage your shop with more than one persons")]), _vm._v(" "), _c('p', [_vm._v("7. Enjoy Shopping pst referrals")]), _vm._v(" "), _c('p', [_vm._v("8. Offer Discounts and Coupon Codes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Items Sold Today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("Qty")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Shopping List")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Market List")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")]), _vm._v("Only Premuim Shop Oners get verified and have access to benefits")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2f74ab2"}!./src/pages/dashboard/template.html
// module id = 627
// module chunks = 0